import styled from 'styled-components';
export const MyCard = styled.a`
    text-decoration: none;
    color: black;
`